/**
 * AddSupplierForm Component
 * UI-komponent för att lägga till ny leverantör
 */

import React from 'react';
import { SupplierFormFields } from './SupplierFormFields';
import { useSupplierForm } from '../hooks/useSupplierForm';

function AddSupplierForm({ suppliers, setSuppliers, users = [], onClose, onSuccess }) {
  const {
    values,
    setValues,
    discounts,
    previewUrl,
    isLoading,
    errorMessage,
    handleChange,
    handleAvatarChange,
    handleRemoveAvatar,
    addDiscount,
    updateDiscount,
    removeDiscount,
    handleSubmit
  } = useSupplierForm({
    initialSupplier: null,
    users,
    onClose,
    onSuccess,
    setSuppliers,
    suppliers,
    isUpdate: false
  });

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Lägg till leverantör</h2>
      <div className="mb-4 bg-blue-50 border border-blue-200 p-4 rounded-lg text-blue-800">
        <div className="flex items-start">
          <svg className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <p>För att hantera kontaktpersoner, skapa först leverantören och sedan användare med rollen "Materialleverantör". Därefter kan du välja huvudkontakt när du redigerar leverantören.</p>
        </div>
      </div>
      {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <SupplierFormFields
          values={values}
          setValues={setValues}
          discounts={discounts}
          previewUrl={previewUrl}
          errorMessage={errorMessage}
          handleChange={handleChange}
          handleAvatarChange={handleAvatarChange}
          handleRemoveAvatar={handleRemoveAvatar}
          addDiscount={addDiscount}
          updateDiscount={updateDiscount}
          removeDiscount={removeDiscount}
          isUpdate={false}
        />
        
        <div className="flex space-x-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-gray-500 text-white p-2 rounded hover:bg-gray-600 
                     transition-colors duration-200"
          >
            Avbryt
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="flex-1 bg-leadme-pink text-white p-2 rounded hover:bg-leadme-pink-dark 
                     disabled:bg-leadme-pink/50 transition-colors duration-200"
          >
            {isLoading ? 'Sparar...' : 'Spara'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddSupplierForm;

